import "rxjs/add/operator/mergeMap";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default (action$) =>
  action$.ofType(Types.GROUP_REGISTRATION).mergeMap(
    (action) =>
      new Promise(async (resolve, reject) => {
        const registrations = action.registrations;

        // combine users in registration's group
        const [combineRegistration, registrationToGroup] = cloneDeep(
          registrations
        );

        const registrationToGroupData = (
          await firebase
            .database()
            .ref(`registrations/${registrationToGroup.registration}`)
            .once("value")
        ).val();
        registrationToGroup.group[0].registrationId =
          registrationToGroup.registration;
        registrationToGroup.group[0].registration = registrationToGroupData;
        registrationToGroup.group.forEach((groupMember) => {
          if (groupMember.minor) {
            groupMember.registrationId = registrationToGroup.registration;
          }
        });
        combineRegistration.group = combineRegistration.group.concat(
          registrationToGroup.group
        );

        const updatePromise = firebase
          .database()
          .ref(
            `queues/${action.location}/${combineRegistration.registrationId}`
          )
          .update(omit(combineRegistration, ["registrationId"]));

        const removePromises = [];
        registrations.forEach((registration) => {
          if (
            combineRegistration.registrationId !== registration.registrationId
          ) {
            const removePromise = firebase
              .database()
              .ref(`queues/${action.location}/${registration.registrationId}`)
              .remove();
            removePromises.push(removePromise);
          }
        });

        Promise.all([updatePromise, ...removePromises])
          .then(() => resolve(Creators.groupRegistrationSucceeded()))
          .catch(() => reject(Creators.groupRegistrationFailed()));
      })
  );



// WEBPACK FOOTER //
// ./src/staff/epics/groupRegistration.js